import type { MessageDescriptor } from 'react-intl';
import type { OneOffChannel } from 'fym-shared/src/music24/oneOffPublish';
import { publishMessages } from './publishMessages';
import { SET_MARK_CHANNELS } from './publishBadgeText';

/**
 * The how-to of a manual mark (design assets-rethink b3): a title, a lead line, the steps and the
 * label of the mark button. Instagram keeps its one-line how-to of the one-off publish. Pure, so
 * the copy choice is tested without React.
 */
export interface ManualHowTo {
  title: MessageDescriptor | null;
  lead: MessageDescriptor;
  steps: MessageDescriptor[];
  markLabel: MessageDescriptor;
  /** True when the label takes `{channel}` (the Instagram "I posted it on Instagram"). */
  markNamesChannel: boolean;
}

export function manualHowTo(channel: OneOffChannel): ManualHowTo {
  if (channel === 'spotifyCanvas') {
    return {
      title: publishMessages.howToTitleCanvas,
      lead: publishMessages.howToLeadCanvas,
      steps: [
        publishMessages.howToCanvas1,
        publishMessages.howToCanvas2,
        publishMessages.howToCanvas3,
        publishMessages.howToCanvas4,
      ],
      markLabel: publishMessages.actionAddedIt,
      markNamesChannel: false,
    };
  }
  if (channel === 'appleMusic') {
    return {
      title: publishMessages.howToTitleApple,
      lead: publishMessages.howToLeadApple,
      steps: [publishMessages.howToApple1, publishMessages.howToApple2, publishMessages.howToApple3],
      markLabel: publishMessages.actionAddedIt,
      markNamesChannel: false,
    };
  }
  if (channel === 'spotifyHeader') {
    return {
      title: publishMessages.howToTitleSpotifyHeader,
      lead: publishMessages.howToLeadSpotifyHeader,
      steps: [
        publishMessages.howToSpotifyHeader1,
        publishMessages.howToSpotifyHeader2,
        publishMessages.howToSpotifyHeader3,
      ],
      markLabel: publishMessages.actionSetIt,
      markNamesChannel: false,
    };
  }
  if (SET_MARK_CHANNELS.includes(channel)) {
    return {
      title: publishMessages.howToTitleSet,
      lead: publishMessages.howToLeadSet,
      steps: [publishMessages.howToSet1, publishMessages.howToSet2, publishMessages.howToSet3],
      markLabel: publishMessages.actionSetIt,
      markNamesChannel: false,
    };
  }
  return {
    title: null,
    lead: publishMessages.instagramHowTo,
    steps: [],
    markLabel: publishMessages.actionMarkPosted,
    markNamesChannel: true,
  };
}
